// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31b6fea3","455":"f732f780"}[chunkId] + ".chunk.js";
};